import getElementProp from './getElementProp';

export default function enableAnimationBreakpoint() {
  const bp = getElementProp(document.documentElement, '--enable-animation-breakpoint');

  return window.matchMedia(`(min-width: ${bp})`).matches;
}